import React from "react"

import useDimensions from "react-use-dimensions"
import "./styles.scss"
import { scaleLinear } from "d3-scale"
import { gradientColors } from "../utils/gradient"
import { useSpring, animated } from "react-spring"

import useDetectPrint from "use-detect-print"
const printFullWidth = 700
const printHalfWidth = printFullWidth - 245

export default function SingleFillGraph(props) {
  const [ref, containerDimensions] = useDimensions()
  const margins = {
    top: 2,
    left: 30 + props.leftMargin,
    right: 30,
    bottom: 2,
  }
  const containerHeight = 26

  let graphContents = null
  let defs = null
  const isPrinting = useDetectPrint()
  const [spring, set] = useSpring(() => ({ value: 0, x: 0 }))

  let containerWidth = containerDimensions.width || 400
  if (isPrinting) {
    containerWidth = printHalfWidth
  }
  let width = containerWidth - margins.left - margins.right
  const xScale = scaleLinear().domain([0, 1]).range([0, width])

  set({ value: props.value, x: xScale(props.value.toFixed(2)) })

  const barHeight = 20

  const { x, value } = spring
  const maskId = `singleFillGraphMaskId-${(
    (Math.random() * 0xffffff) <<
    0
  ).toString(16)}`

  graphContents = (
    <g transform={`translate(${margins.left + 0.5}, ${margins.top + 0.5})`}>
      <rect
        width={width}
        height={barHeight}
        stroke="#707070"
        fill="#ebebeb"
        strokeWidth="0.5"
      />
      <rect
        width={width}
        height={barHeight}
        fill="url(#singleFillGraphGradient)"
        mask={`url(#${maskId})`}
      />
      <animated.line
        x1={x}
        x2={x}
        strokeWidth={3}
        y1={barHeight}
        stroke="black"
      />
      <text x={-5} y={16} textAnchor="end" className="graphAxisLabel">
        {props.leftAxisLabel}
      </text>
      <text x={width + 5} y={16} className="graphAxisLabel">
        {props.rightAxisLabel}
      </text>
      <animated.text
        transform="translate(5, 0)"
        x={x}
        y={barHeight - 5}
        textAnchor="start"
      >
        {value.interpolate((n) => n.toFixed(2))}
      </animated.text>
    </g>
  )

  defs = (
    <React.Fragment>
      <mask id={maskId}>
        <animated.rect width={x} height={barHeight} fill="#fff" />
      </mask>
    </React.Fragment>
  )
  return (
    <div ref={ref} className="singleFillGraphWrapper">
      <svg width={containerWidth} height={containerHeight}>
        <defs>
          <linearGradient id="singleFillGraphGradient">
            {gradientColors.map((color) => (
              <stop
                key={color.offset}
                offset={`${color.offset}%`}
                stopColor={color.hex}
              />
            ))}
          </linearGradient>
          {defs}
        </defs>
        {graphContents}
      </svg>
    </div>
  )
}

SingleFillGraph.defaultProps = {
  leftMargin: 0,
}
